/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AlertExecutionDto } from '../../models/alert-execution-dto';

export interface AlertsAlertRuleIdHistoryGet$Json$Params {
  alertRuleId: string;
  page?: number;
  pageSize?: number;
}

export function alertsAlertRuleIdHistoryGet$Json(http: HttpClient, rootUrl: string, params: AlertsAlertRuleIdHistoryGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AlertExecutionDto>>> {
  const rb = new RequestBuilder(rootUrl, alertsAlertRuleIdHistoryGet$Json.PATH, 'get');
  if (params) {
    rb.path('alertRuleId', params.alertRuleId, {});
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AlertExecutionDto>>;
    })
  );
}

alertsAlertRuleIdHistoryGet$Json.PATH = '/alerts/{alertRuleId}/history';
